import Site from 'interfaces/Site';
import {MinimumSiteInfoApi} from './minimumSiteInfoReducer';
import {getSiteTypeFromSiteId} from 'utils/utils';
import SiteType from 'constants/SiteType';

const getSiteCode = (site: MinimumSiteInfoApi): string => {
  const siteNumberFromId: string = site.SiteId.substring(3, 7);
  const convertToNumber = Number(siteNumberFromId);

  if (!isNaN(convertToNumber)) {
    return convertToNumber.toString();
  } else {
    return siteNumberFromId;
  }
};

const getSiteDisplayName = (site: MinimumSiteInfoApi): string => {
  const siteNumber = getSiteCode(site);

  return `${siteNumber} ${site.SiteName}`;
};

function siteInfoFormat(
  apiSites: MinimumSiteInfoApi[]
): {sites: Site[]; allSiteTypes: Set<SiteType>} {
  const allSiteTypes = new Set<SiteType>();
  const allSiteKeys = new Set<string>();
  const siteTypeProperties = new Set<string>();

  const sites: Site[] = apiSites.map((apiSite, index) => {
    const {Brand, SiteName, SiteId, Geo, Address} = apiSite;
    const siteCode = getSiteCode(apiSite).toString();
    const displayName = getSiteDisplayName(apiSite);
    const siteType = getSiteTypeFromSiteId(SiteId);

    const siteTypeChar = SiteId[2];
    allSiteKeys.add(siteTypeChar);
    siteTypeProperties.add(apiSite.SiteType);

    allSiteTypes.add(siteType);
    const address = Object.values(Address)
      .filter(value => value.length > 0)
      .join('|');
    const combinedSearchData = `${SiteId}|${SiteName}|${Brand}|${Geo}|${siteCode}|${displayName}|${siteType}|${siteCode}|${address}`;
    const siteSearch = combinedSearchData.toLowerCase();
    const id = `${index.toString()}${SiteId}`;

    return {
      siteId: SiteId,
      siteName: SiteName,
      brand: Brand,
      geo: Geo,
      address: Address,
      siteCode,
      displayName,
      siteType,
      siteSearch,
      id,
    };
  });

  return {sites, allSiteTypes};
}

export default siteInfoFormat;
